import React, { useState } from "react";
import "./Setting.scss";
import UsersettingImg from "../../../assets/images/UsersettingImg.png";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import axios from "axios";

const Setting = () => {
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
  const navigate = useNavigate();

  const Logout = () => {
    try {
      localStorage.removeItem("bearerToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("phone");
      localStorage.removeItem("name");

      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  const [checkNumber, setCheckNumber] = useState(null);

  const [number, setNumber] = useState(null);
  const handleInputChange = (value) => {
    console.log("Number :", value);

    setNumber(value);
    if (value && isValidPhoneNumber(value.toString()) != false) {
      setCheckNumber(true);
    } else {
      setCheckNumber(false);
    }
  };

  const UpdateAgent = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/customer`,
        {
          number: "123456789",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log(response.data._id, "data======");
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  return (
    <div>
      <div className="setting-main-container">
        {/* <div className="General-head-txt">General Settings</div> */}
        <form className="setting-main-form-box">
          <span className="d-flex align-items-center">
            <label htmlFor="">Profile picture</label>
            <div className="d-flex align-items-center">
              <img src={UsersettingImg} alt="" />
              <div>
                <label for="fileInput" class="upload-label">
                  Upload image
                </label>
                <input type="file" id="fileInput" style={{ display: "none" }} />
              </div>
            </div>
          </span>
          <span className="d-flex align-items-center setting-span-2">
            <label htmlFor="">Update Email address:</label>
            <div className="d-flex align-items-center">
              <input type="text" />
            </div>
          </span>

          <span className="d-flex align-items-center setting-span-2">
            <label htmlFor="">Contact Number:</label>
            <div className="d-flex align-items-center">
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry="CA"
                value={number}
                onChange={(value) => handleInputChange(value)}
                autoComplete="off"
              />
            </div>
          </span>

          <span className="d-flex align-items-center setting-span-2">
            <label htmlFor="">Clear all Chats</label>
            <div className="d-flex align-items-center">
              <button className="clearBtn">Clear</button>
            </div>
          </span>
          <span className="d-flex align-items-center setting-span-2">
            <label htmlFor="">Clear Call History</label>
            <div className="d-flex align-items-center">
              <button className="clearBtn">Clear</button>
            </div>
          </span>

          <span className="d-flex align-items-center setting-span-2">
            <label htmlFor="">Push Notifications</label>
            <div className="d-flex align-items-center">
              <div class="check-box">
                <input type="checkbox" className="skip-stream" />
              </div>
            </div>
          </span>
          <span className="d-flex align-items-center setting-span-2">
            <label htmlFor="">Email Notifications</label>
            <div className="d-flex align-items-center">
              <div class="check-box">
                <input type="checkbox" className="skip-stream" />
              </div>
            </div>
          </span>

          <button className="themebtn-1 mt-2 mr-3">Save</button>
          <button className="themebtn-1 mt-2 " onClick={Logout}>
            Logout
          </button>
        </form>
      </div>
    </div>
  );
};

export default Setting;
